import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Объединяет className-значения и нормализует коллизии Tailwind-утилит
 * (`px-4 px-6` → `px-6`, `text-ink text-ink-inverse` → `text-ink-inverse`).
 *
 * Используется в связке с `cva()` для сборки вариантов компонентов и слияния
 * с пользовательским `class` из атрибутов-дополнений.
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-accent', props.class)
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
